import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const NotFound = () => {
  return (
    <section className='not-found'>
      <div className='container1 not-found'>
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          size='3x'
          color='#ffc107'
        />
        <h2>404 Pagina nu exista</h2>
        <Link to='/'>
          <button className='btn'>Acasa</button>
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
